export enum TimeLimitsEnum {
  TKT = 'TKT',
  DEP = 'DEP',
  PAY = 'PAY',
  NME = 'NME',
  AGT = 'AGT'
}
